module.exports = __webpack_public_path__ + "img/16-03_Building A Personal Network.d70cfc2b.svg";